import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./IncidentChartFilter.scss"; // for styles
import { CHART_FILTERED_LIST } from "../mdrConstants";

const IncidentChartFilter = () => {
  const dispatch = useDispatch();
  const incidents = useSelector(
    (state) => state.mdrReducer.mdrDashboardIncidentList
  );

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.trim() === "") {
      dispatch({ type: CHART_FILTERED_LIST, payload: [] });
    } else {
      const filtered = incidents.filter((incident) =>
        incident.incidentType.toLowerCase().includes(value.toLowerCase())
      );
      dispatch({ type: CHART_FILTERED_LIST, payload: filtered });
    }
  };

  return (
    <div className="chart-filter">
      <div className="chart-filter-label">Chart Filter</div>
      <input
        type="text"
        placeholder="All Incidents"
        value={searchTerm}
        onChange={handleSearch}
        className="chart-filter-input"
      />
    </div>
  );
};

export default IncidentChartFilter;
